<template>
  <div class="input-search__wrapper">
    <div class="input-search">
      <FontAwesomeIcon v-if="value.length === 0" icon="search" />
      <FontAwesomeIcon
        v-else
        class="reset"
        @click="value = ''; $emit('input', '')"
        icon="times"
      />

      <input
        type="text"
        :value="value"
        @input="$emit('input', $event.target.value)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputSearch',
  props: ['value']
}
</script>

<style lang="scss" scoped>
  .input-search {
    position: relative;

    &__wrapper {
      position: sticky;
      top: 0;
      padding: 30px 0;
      background: #fff;
    }

    svg {
      position: absolute;
      top: 50%;
      left: 10px;
      transform: translateY(-50%);
      color: map-get($color-util, 'muted');
      font-size: 1.5rem;
    }

    .reset {
      color: #5300aa;
      cursor: pointer
    }

    input {
      width: 100%;
      height: 40px;
      padding: 0 20px 0 40px;
      border: 1px solid map-get($color-util, 'lighter');
      border-radius: 4px;
      outline: 0;
      transition: all 0.1s;
      background: #fff;
      color: map-get($color-util, 'light');
      font: {
        size: 1.2rem;
        family: $font-regular;
      }

      &:focus {
        border-color: map-get($color-util, 'light');
        color: map-get($color-util, 'darkest');
      }
    }

    // Responsiveness
    @include media(map-get($breakpoint, 'medium')) {}
  }
</style>
